import { Component, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { FaqService } from 'src/app/shared/services/faq.service';

@Component({
  selector: 'app-footer-sped',
  templateUrl: './footer-sped.component.html',
  styleUrls: ['./footer-sped.component.scss']
  
})
export class FooterSpedComponent implements OnInit {
  
  public today: Date = new Date();

  urlBlobPdf: SafeUrl;

  constructor(
    private faqService: FaqService
    ) { }

  ngOnInit() {
    this.urlBlobPdf = this.faqService.obterUrlBlob().subscribe(
      url => this.urlBlobPdf = url
    );
  }

}
